import { cloneArr, Module } from '@nu-art/ts-common';
import { StorageKey } from '@nu-art/thunderstorm-frontend/index';
import { dispatch_onRequestHistoryChanged } from '../Page_BaseSandbox/Base_RequestHistory/index.js';
export class ModuleFE_BaseSandboxModule extends Module {
    templates;
    history;
    constructor(key, templates) {
        super();
        this.templates = templates;
        this.history = new StorageKey(key);
    }
    // Get Templates
    async listTemplates() {
        return this.templates;
    }
    setTemplates(templates) {
        this.templates = templates;
        return this;
    }
    // History management
    addMessageToHistory(historyItem) {
        const messageHistory = cloneArr(this.getHistory());
        messageHistory.push(historyItem);
        this.history.set(messageHistory);
        dispatch_onRequestHistoryChanged.dispatchUI();
    }
    addErrorMessageToHistory(error) {
        const messageHistory = cloneArr(this.getHistory());
        messageHistory.push({ type: 'error', content: error });
        this.history.set(messageHistory);
        dispatch_onRequestHistoryChanged.dispatchUI();
    }
    getHistory() {
        return this.history.get([]);
    }
    clearHistory() {
        this.history.delete();
    }
}
//# sourceMappingURL=ModuleFE_BaseSandboxModule.js.map